import { ContentLayout } from "@2u-landing-pages/components/ContentLayout";
import { Container } from "@red-digital/bricks";
import React from "react";
import { BentoItemGroup, BentoProps } from "../../Bento.types";
import { Tiles } from "../../Tiles";
// @ts-ignore
import styles from "./Default.module.scss";

export const Default: React.FC<BentoProps> = ({
  variation,
  embedded,
  section_heading,
  secondary_heading,
  items_group_one,
  items_group_two,
  items_group_three,
  tile_background_color,
  phoneNumber,
  style,
}) => {
  const groups = [items_group_one, items_group_two, items_group_three].filter((val) => val) as BentoItemGroup[];

  return (
    <Container className={styles.bento} style={style}>
      {section_heading && (
        <ContentLayout
          className={styles.sectionHeading}
          content={section_heading}
          phoneNumber={phoneNumber}
        />
      )}

      <Container>
        {variation === "extended" ? (
          <Container className={styles.bentoContainer}>
            {secondary_heading && (
              <ContentLayout
                className={styles.secondaryHeading}
                content={secondary_heading}
                heading={{ variant: "heading-xl" }}
                phoneNumber={phoneNumber}
              />
            )}
            <Tiles
              embedded={embedded}
              groups={groups}
              tile_background_color={tile_background_color}
              variation={variation}
              phoneNumber={phoneNumber}
            />
          </Container>
        ) : (
          <Tiles
            embedded={embedded}
            groups={groups}
            tile_background_color={tile_background_color}
            variation={variation}
            phoneNumber={phoneNumber}
          />
        )}
      </Container>
    </Container>
  );
};
